import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Button } from "./ui/button";
import {
  LogOut,
  Sun,
  Moon,
  Menu,
  X,
  UserIcon,
  Boxes,
  Key,
  ChartColumnIncreasing,
  Building2,
  CreditCard,
} from "lucide-react";
import logo from "../../src/assets/RWA-Logo-Admin.png";

interface AppBarProps {}

export const AppBar: React.FC<AppBarProps> = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const routes = [
    {
      label: "Analytics",
      icon: ChartColumnIncreasing,
      href: "/analytics",
    },
    {
      label: "Users",
      icon: UserIcon,
      href: "/users",
    },
    {
      label: "Assets",
      icon: Boxes,
      href: "/assets",
    },
    {
      label: "Amenities",
      icon: Building2,
      href: "/amenities",
    },
    {
      label: "Rentals",
      icon: Key,
      href: "/rental",
    },
    {
      label: "Transactions",
      icon: CreditCard,
      href: "/transactions",
    },
  ];

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    navigate("/analytics");
    window.location.reload();
  };

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  return (
    <div className="fixed top-0 left-0 right-0 z-50 bg-background dark:bg-background border-b border-surface-2 dark:border-surface-2 transition-colors duration-200 shadow-md">
      <div className="flex h-16 items-center px-4">
        <Button
          variant="ghost"
          size="icon"
          className="lg:hidden mr-2 text-black hover:bg-surface-2 dark:hover:bg-surface-2"
          onClick={toggleMobileMenu}
        >
          {mobileMenuOpen ? (
            <X className="h-5 w-5" />
          ) : (
            <Menu className="h-5 w-5" />
          )}
        </Button>
        <div className="flex items-center gap-2 text-2xl lg:text-2xl text-xl font-bold text-black">
          <img
            src={logo}
            alt="RWA Logo"
            className="h-9 w-auto border border-transparent dark:border-gray-600 rounded"
          />
        </div>
        <div className="flex-1" />
        {/* <Button
          variant="ghost"
          size="sm"
          className="flex items-center gap-2 text-black hover:bg-surface-2 dark:hover:bg-surface-2 mr-2"
          onClick={toggleTheme}
        >
          {isDarkMode ? (
            <Sun className="h-4 w-4" />
          ) : (
            <Moon className="h-4 w-4" />
          )}
        </Button> */}
        <Button
          variant="ghost"
          size="sm"
          className="flex items-center gap-2 text-black hover:bg-surface-2 dark:hover:bg-surface-2"
          onClick={handleLogout}
        >
          <LogOut className="h-4 w-4" />
          <span className="hidden sm:inline">Logout</span>
        </Button>
      </div>

      {/* Mobile Navigation Dropdown */}
      {mobileMenuOpen && (
        <div className="lg:hidden absolute w-full bg-background dark:bg-background border-b border-surface-2 dark:border-surface-2 shadow-md z-50">
          <div className="p-4 space-y-2">
            {routes.map((route) => {
              const isActive = location.pathname === route.href;
              return (
                <div
                  key={route.href}
                  className={`flex items-center p-2 rounded-md cursor-pointer ${
                    isActive
                      ? "bg-secondary text-black"
                      : "hover:bg-surface-2 dark:hover:bg-surface-2"
                  }`}
                  onClick={() => {
                    navigate(route.href);
                    setMobileMenuOpen(false);
                  }}
                >
                  <route.icon
                    className={`h-5 w-5 mr-3 ${isActive ? "text-black" : "text-black"}`}
                  />
                  <span className={isActive ? "text-black" : "text-black"}>
                    {route.label}
                  </span>
                </div>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
};
